import { createAssignmentWidgetSlice } from "../createAssignmentWidgetSlice";
import { fetchProposalSectionsAssignment } from "./actions";

const proposalSectionsAssignmentSlice = createAssignmentWidgetSlice({
  name: "proposalSectionsAssignment",
  fetchThunk: fetchProposalSectionsAssignment,
  defaultError: "Failed to load sections assignment",
});

export default proposalSectionsAssignmentSlice.reducer;
